module.exports = __webpack_public_path__ + "static/apple-touch-icon-120x120-24aa423e412d09d438c7035701bb3e22.png";